import { FC, useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { GET_TENANT_INFO_BY_USER_ID } from 'graphql/service'
import { Booking } from 'types/commonTypes'
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';

export const getReservationCompleteMessage = (reservationCode: string) =>
  `Your reservation is complete! Your confirmation number is ${reservationCode}.`

const CompleteAlert: FC<{
  userId?: string
  receivedReservationCode?: string
}> = ({ userId, receivedReservationCode }) => {

  const { showGlobalMessage, showGlobalError } = useGlobalAlerts();
  const [reservationCode, setReservationCode] = useState(receivedReservationCode)

  const [getTenantInfoByUserId] = useLazyQuery(
    GET_TENANT_INFO_BY_USER_ID,
    {
      variables: { userId },
      onCompleted: (tenantInfoData) => {
        const bookings =
          tenantInfoData.tenantByUserID?.groups?.[0]?.group.bookings || []

        const code = bookings.find(
          (booking: Booking) => booking.tenantGroup?.isPrimaryTenant === true
        )?.reservationCode

        setReservationCode(code)
      },
      onError: (error) => {
        console.log(error.message)
        showGlobalError(error.message)
      }
    }
  )

  useEffect(() => {
    if (userId) {
      getTenantInfoByUserId()
    }
  }, [userId, getTenantInfoByUserId])

  useEffect(() => {
    if (reservationCode) {
      showGlobalMessage(
        getReservationCompleteMessage(reservationCode), false, '/check-out-confirm'
      )
    }
  }, [reservationCode, showGlobalMessage])

  return null
}

export default CompleteAlert
